import React from 'react';
import { render } from '@testing-library/react';
import { FlowCard } from './FlowCard';
import { BodyText } from '../BodyText';
import { Button } from '../Button';

describe('FlowCard', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<FlowCard currentIndex={1} data-auto-sel="automation-selector">
				<FlowCard.Step
					content={
						<BodyText subdued italic>
							How do you want to track if this campaign is
							successful?
						</BodyText>
					}
					headerAction={
						<Button fill="outline" small primary>
							Add Goal
						</Button>
					}
				/>
			</FlowCard>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<FlowCard currentIndex={1}>
				<FlowCard.Step
					content={
						<BodyText subdued italic>
							How do you want to track if this campaign is
							successful?
						</BodyText>
					}
					headerAction={
						<Button fill="outline" small primary>
							Add Goal
						</Button>
					}
					data-auto-sel="automation-selector"
				/>
			</FlowCard>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
